import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <p className="mb-0">
          &copy; {currentYear} Optical Data Manager. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
